/*
 * Veridermis custom components — kept separate from Prestige per Maestrooo
 * customization rules (do not edit theme.js).
 *
 * <veri-shipping-bar>: drop-in replacement for Prestige's <free-shipping-bar>
 * that converts the free-shipping threshold (entered in the STORE currency,
 * USD) into the visitor's presentment currency using Shopify's live FX rate
 * (window.Shopify.currency.rate). Without this, a threshold of "50" reads as
 * 50 CAD / 50 GBP for international visitors while checkout actually requires
 * USD $50, over-promising free shipping abroad.
 *
 * Conversion happens in the constructor, so every instantiation — first
 * paint, cart-drawer re-render, section morph — is correct by construction.
 */
(function () {
  if (window.customElements.get('veri-shipping-bar')) return;

  class VeriShippingBar extends HTMLElement {
    constructor() {
      super();
      var rate = parseFloat((window.Shopify && Shopify.currency && Shopify.currency.rate) || '1') || 1;
      var base = parseFloat((this.getAttribute('threshold') || '0').replace(/[^0-9.]/g, '')) || 0;
      this._threshold = base * rate * 100; // presentment-currency cents
      this._formatter = new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active
      });
      this._onCartChanged = this._onCartChanged.bind(this);
    }

    static get observedAttributes() {
      return ['total-price'];
    }

    connectedCallback() {
      document.addEventListener('cart:change', this._onCartChanged);
      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener('cart:change', this._onCartChanged);
    }

    attributeChangedCallback() {
      this._update();
    }

    _onCartChanged(event) {
      var cart = event.detail && event.detail.cart;
      if (!cart) return;
      var items = cart.items
        .filter(function (item) { return item.requires_shipping; })
        .reduce(function (sum, item) { return sum + item.final_line_price; }, 0);
      var discount = cart.cart_level_discount_applications
        .reduce(function (sum, d) { return sum + d.total_allocated_amount; }, 0);
      this.setAttribute('total-price', items - discount);
    }

    _update() {
      var messageElement = this.querySelector('span');
      if (!messageElement) return;
      var total = parseFloat(this.getAttribute('total-price')) || 0;
      if (total >= this._threshold) {
        messageElement.innerHTML = this.getAttribute('reached-message');
      } else {
        var remaining = this._formatter
          .format((this._threshold - total) / 100)
          .replace(/\$/g, '$$$$');
        messageElement.innerHTML = (this.getAttribute('unreached-message') || '')
          .replace(new RegExp('({{.*}})', 'g'), remaining);
      }
    }
  }

  window.customElements.define('veri-shipping-bar', VeriShippingBar);
})();

/*
 * Announcement-bar currency localization.
 *
 * Static section text like "Free worldwide shipping on orders over $50" is
 * authored in the STORE currency (USD). For visitors browsing in another
 * currency, every "$N" would wrongly read as N units of THEIR currency.
 * This rewrites $-amounts inside the announcement bar (and any element
 * marked with [data-convert-usd]) into the presentment currency using
 * Shopify's live FX rate, rounded UP to a whole number so the stated
 * free-shipping promise is always conservative (never under-states the
 * real USD threshold). Example: "$50" -> "CA$71" / "£38" / "€43".
 */
(function () {
  function convertUsdAmounts() {
    if (!window.Shopify || !Shopify.currency) return;
    var rate = parseFloat(Shopify.currency.rate || '1') || 1;
    if (Shopify.currency.active === 'USD' || rate === 1) return;
    var formatter = new Intl.NumberFormat(Shopify.locale, {
      style: 'currency',
      currency: Shopify.currency.active,
      maximumFractionDigits: 0
    });
    var targets = document.querySelectorAll('[id*="__announcement_bar"] p.prose, [data-convert-usd]');
    targets.forEach(function (el) {
      if (el.dataset.usdConverted) return;
      var html = el.innerHTML;
      var out = html.replace(/\$\s?(\d+(?:\.\d{2})?)/g, function (match, amount) {
        return formatter.format(Math.ceil(parseFloat(amount) * rate));
      });
      if (out !== html) {
        el.innerHTML = out;
        el.dataset.usdConverted = '1';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertUsdAmounts);
  } else {
    convertUsdAmounts();
  }
})();
